import React from 'react'
import { Divider as MuiDivider, styled } from '@mui/material'

const StyledDivider = styled(MuiDivider)(
    ({ color, width, height, vertical }) => ({
        backgroundColor: color,
        borderColor: color,
        width: width,
        height: height,
        transform: vertical ? 'rotate(90deg)' : '',
    }),
)

const Divider = (props) => {
    const { color, width, height, vertical, ...rest } = props
    return (
        <StyledDivider
            color={color}
            width={width}
            height={height}
            vertical={vertical}
            {...rest}
        />
    )
}

Divider.defaultProps = {
    color: '#e8e8e8',
    height: '0.1rem',
}

export default Divider
